export const getCampaignActions = (
  onView,
  onEdit,
  onStatusChange,
  onVisibilityChange
) => [
  {
    label: "Visualizar",
    icon: "view",
    color: "primary",
    isVisible: () => true,
    onClick: (item) => onView(item),
  },
  {
    label: "Editar",
    icon: "edit",
    color: "primary",
    isVisible: () => true,
    onClick: (item) => onEdit(item),
  },
  {
    label: "Desativar",
    icon: "pause",
    color: "warning",
    isVisible: (item) => item?.status === "Active",
    onClick: (item) => onStatusChange(item),
  },
  {
    label: "Ativar",
    icon: "play",
    color: "success",
    isVisible: (item) => item?.status === "Desativado",
    onClick: (item) => onStatusChange(item),
  },
  {
    label: "Ocultar",
    icon: "view-off",
    color: "warning",
    isVisible: (item) => item?.Visibility === "Visível",
    onClick: (item) => onVisibilityChange(item),
  },
  {
    label: "Exibir",
    icon: "view",
    color: "success",
    isVisible: (item) => item?.Visibility === "Oculto",
    onClick: (item) => onVisibilityChange(item),
  },
];
